import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Card, Link, Container, Typography, Stack } from '@mui/material';
import Page from '../components/Page';
import { ChangePasswordForm } from 'src/sections/authentication/changePassword';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  },
  backgroundColor: process.env.REACT_APP_BACKGROUND
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 450,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: 43
}));

export default function ChangePassword() {
  return (
    <RootStyle title={`Change Password | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src={process.env.REACT_APP_LOGIN}
              sx={{
                padding: 1,
                marginLeft: 1,
                width: 140,
                height: 140
              }}
            />

            <Typography sx={{ fontSize: 25, fontFamily: 'poppinsBold' }}>
              Change your password
            </Typography>
          </Stack>
          <ChangePasswordForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
